import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as SectorServices from "../../../../services/SectorService";
import { useTranslation } from "react-i18next";
import SectorForm from "./sectorForm.view";
import PATHS from "../../../../constants/paths";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import * as LocationService from "../../../../services/LocationService";
import * as ViveroService from "../../../../services/ViveroService";

const SectorFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [locations, setLocations] = useState([]);
  const [viveros, setViveros] = useState([]);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      active: data.active,
      locationUuid: data.locationUuid,
      rowsAB: data.rowsAB,
      rows: data.rows,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultViveros = await ViveroService.getAllViveros({
      filters: { active: true },
    });
    if (resultViveros && resultViveros.length > 0) {
      const dataViveros = resultViveros.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setViveros(dataViveros);
    }
    if (uuid) {
      const result = await SectorServices.getSector(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await SectorServices.updateSector(values, uuid);
        } else {
          result = await SectorServices.addSector(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.sector.messages.update.title");
            text = t("forms.sector.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.sector.messages.create.title");
            text = t("forms.sector.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.sector.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.SECTOR_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.SECTOR_LIST);
  };

  const handlerOnChangeVivero = async (value) => {
    const resultItems = await LocationService.getAllLocations({
      filters: { active: true, viveroUuid: value },
    });
    if (resultItems && resultItems.length > 0) {
      const data = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setLocations(data);
    } else {
      setLocations([]);
    }
  };

  return (
    <SectorForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
      locations={locations}
      viveros={viveros}
      onChangeVivero={handlerOnChangeVivero}
    />
  );
};

SectorFormContainer.propTypes = {
  t: PropTypes.any,
};

export default SectorFormContainer;
